import { MydAPI } from '_services/default'


export const newSupportMessage = (data) => {
  return new Promise((resolve, reject) => {
    MydAPI.post('/support', {
      data: {
        attributes: {
          subject: data.subject,
          body: data.body,
          file_url: data.fileUrl,
        },
        type: 'support_message',
      }
    }).then(resolve).catch(reject)
  })
}


export const newSupportTech = (data) => {
  return new Promise((resolve, reject) => {
    MydAPI.post('/support/tech', {
      data: {
        attributes: {
          subject: data.subject,
          body: data.body,
        },
        type: 'support_tech',
      }
    }).then(resolve).catch(reject)
  })
}
